import _ from 'underscore';

export const switchExpertModalLocalization = {
  SwitchForm_Close: _TL_('Close'),
  SwitchExpertModal_Header: _TL_('Are you sure you want to switch to Expert Mode?'),
  SwitchExpertModal_BodyLabel: _TL_('Expert Mode lets you take advantage of all the features Microsoft Advertising has to offer, such as:'),
  SwitchExpertModal_Feature1: _TL_('Add more content to your ads'),
  SwitchExpertModal_Feature2: _TL_('More detailed reporting and conversion tracking'),
  SwitchExpertModal_Feature3: _TL_('Automated bid strategies and other tools to increase efficiency'),
  SwitchExpertModal_LinkLearnMore: _TL_('Learn more about Smart Mode vs Expert Mode'),
  SwitchExpertModal_ButtonStay: _TL_('Stay in Smart Mode'),
  SwitchExpertModal_ButtonSwitch: _TL_('Switch to Expert Mode'),
};

export const BingAdsSwitchModalStrings = _.extend(
  {},
  switchExpertModalLocalization
);

